module.exports = __webpack_public_path__ + "img/car-24.52d40561.jpg";